import { SearchStore } from '@libs/common-types';

export function myStoreFirstSort(items: SearchStore[], myStoreNumber?: number) {
    if (!myStoreNumber) {
        return items;
    }

    const index = items.findIndex(item => item.Store.StoreNumber === myStoreNumber);

    if (index > 0) {
        const [item] = items.splice(index, 1); // Remove the item
        items.unshift(item); // Move it to the front
    }

    return items;
}
